import { IDeductionDocumentUploadRepository, DeductionDocumentUploadResponse } from "@/core/repositories/deduction";


export class UploadDeductionDocumentUseCase {
    constructor(private readonly deductionDocumentUploadRepository: IDeductionDocumentUploadRepository) { }

    async execute(file: File): Promise<DeductionDocumentUploadResponse> {
        return this.deductionDocumentUploadRepository.uploadDocument(file);
    }
}
